import React, { useRef, useEffect, useState } from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import { Skeleton, TextField, Tooltip } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { usePrompt } from "../../Hooks/useBlocker";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { DragDropContext } from "react-beautiful-dnd";
import { Draggable } from "react-beautiful-dnd";
import { Droppable } from "react-beautiful-dnd";
import Actions from "./Actions";
import RegularTableRow from "./RegularTableRow";
import SingleTableRow from "./SingleTableRow";

function Body({
  rows,
  filteredColumns,
  columns,
  options,
  editIndex,
  setEditIndex,
  rowCopy,
  setRowCopy,
}) {
  const [saved, setSaved] = useState(true);

  const previousValue = useRef(null);
  const currentFocus = useRef([]);

  const isFirstRender = useRef(true);

  usePrompt("If you leave without saving you will loss your data?", !saved);

  // useEffect(() => {
  //   //console.log(currentFocus);
  // }, [currentFocus]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // console.log("rowCopy");

    if (!rowCopy) return;

    options?.onChange?.(rows, rowCopy);
  }, [rowCopy]);

  function validate(row) {
    // console.log("running validate");
    function save() {
      options?.save(rowCopy, row);
      //console.log("validate1");

      setSaved(true);

      setEditIndex(false);

      setRowCopy(false);
    }

    function fillRequerments() {
      alert("Please fill in all required information");

      //console.log(currentFocus, rowCopy);

      function focus(i) {
        setTimeout(() => currentFocus.current[i].focus(), 500);
      }

      let i = 0;
      let done = false;
      do {
        if (row[options?.singleRowId]) {
          if (
            columns.find((item) => item.id === options?.singleRowId)
              ?.required === true
          ) {
            if (!rowCopy[options?.singleRow]) {
              //console.log(i, currentFocus);

              focus(0);

              done = true;
            }
          }
          done = true;
        } else {
          if (columns[i].required === true) {
            if (!rowCopy[columns[i].id]) {
              //console.log(i, currentFocus.current);

              focus(i);

              done = true;
            }
          } else {
            if (!columns[i]) {
              done = true;
            }
          }
        }

        i += 1;
      } while (done === false);

      setSaved(false);
    }

    if (row[options.singleRowId] === true) {
      if (row[options.singleRow]) {
        save();
      } else {
        fillRequerments();
      }
    } else {
      const filledRequerments = filteredColumns
        .filter(
          (item) => item.required === true && item.id !== options.singleRowId
        )
        .map((column, i) => {
          if (rowCopy[column.id]) {
            return true;
          } else {
            return false;
          }
        });

      if (!filledRequerments.includes(false)) {
        save();
      } else {
        fillRequerments();
      }
    }
  }

  function onDragEnd(r, rowCopy) {
    //console.log(r);
    options.onDragEnd?.(r);
  }

  return (
    <DragDropContext onDragEnd={(r) => onDragEnd(r)}>
      <TableBody
        sx={{
          width: "100%",
          height: "100%",
          minHeight: 0,
        }}
      >
        <Droppable droppableId={"1"} key={1} index={1}>
          {(provided) => (
            <Box ref={provided.innerRef} {...provided.droppableProps}>
              {rows?.map((row, index) => {
                if (row[options.singleRowId]) {
                  return (
                    <Draggable
                      key={index}
                      draggableId={String(row["draggableId"])}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <SingleTableRow
                          index={index}
                          provided={provided}
                          row={row}
                          editIndex={editIndex}
                          saved={saved}
                          currentFocus={currentFocus}
                          validate={validate}
                          setSaved={setSaved}
                          setEditIndex={setEditIndex}
                          rowCopy={rowCopy}
                          setRowCopy={setRowCopy}
                          columns={columns}
                          options={options}
                        />
                      )}
                    </Draggable>
                  );
                } else {
                  return (
                    <Draggable
                      key={index}
                      draggableId={String(row["draggableId"])}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <RegularTableRow
                          index={index}
                          provided={provided}
                          row={row}
                          snapshot={snapshot}
                          editIndex={editIndex}
                          saved={saved}
                          currentFocus={currentFocus}
                          validate={validate}
                          setSaved={setSaved}
                          setEditIndex={setEditIndex}
                          rowCopy={rowCopy}
                          setRowCopy={setRowCopy}
                          columns={columns}
                          options={options}
                          filteredColumns={filteredColumns}
                        />
                      )}
                    </Draggable>
                  );
                }
              })}
            </Box>
          )}
        </Droppable>

        <Box sx={{ height: "80px" }}></Box>
      </TableBody>
    </DragDropContext>
  );
}

export default Body;
